import React, { type FunctionComponent, useMemo } from 'react'
import { FormattedMessage } from 'react-intl'
import styled from '@emotion/styled'
import { colors } from 'ic-snacks'
import { addHours } from 'legacy/common/dateUtils'
import FormattedTimeWithOffset from 'legacy/components/FormattedTimeWithOffset'
import HourHeader from 'domains/shifts/components/HourHeader'
import RowHeader from 'domains/shifts/components/RowHeader'
import { useShiftManagementContext } from 'domains/shifts/components/contexts/ShiftManagementContext'

const Container = styled.div<{ isWeeklyView: boolean }>(({ isWeeklyView }) => ({
  display: 'flex',
  height: '48px',
  borderBottomWidth: '1px',
  borderBottomStyle: 'solid',
  borderBottomColor: isWeeklyView ? 'transparent' : colors.GRAY_93,
}))

interface Props {
  zoneOffset: number
  zone: string
  isWeeklyView?: boolean
  regularStoreOpen?: Date
  regularStoreClose?: Date
}

const ShiftsHeader: FunctionComponent<Props> = props => {
  const {
    storeHours: { regularStoreOpen, regularStoreClose },
  } = useShiftManagementContext()
  const {
    zone,
    isWeeklyView,
    regularStoreOpen: regularStoreOpenProp,
    regularStoreClose: regularStoreCloseProp,
    zoneOffset,
  } = props
  const computedHours = useMemo(() => {
    let start = regularStoreOpenProp || regularStoreOpen
    const end = regularStoreCloseProp || regularStoreClose
    const hours = []
    while (start < end) {
      hours.push(
        <HourHeader key={start.toString()} isWeeklyView={isWeeklyView}>
          <FormattedTimeWithOffset format="h A" value={start} offset={zoneOffset} />
        </HourHeader>
      )
      start = addHours(start, 1)
    }
    return hours
  }, [
    isWeeklyView,
    regularStoreOpenProp,
    regularStoreCloseProp,
    regularStoreClose,
    regularStoreOpen,
    zoneOffset,
  ])

  return (
    <Container isWeeklyView={isWeeklyView}>
      <RowHeader isWeeklyView={isWeeklyView}>
        <FormattedMessage
          id="shiftsDomain.time"
          values={{
            zone,
          }}
        />
      </RowHeader>
      {computedHours}
    </Container>
  )
}

export default ShiftsHeader
